"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isMobile;
function isMobile() {
  return typeof window !== 'undefined' && window.innerWidth < 992;
}